<template>
    <i class="" :class="[icon, color, size, {'fa-spin': spin}, {'fa-pulse': pulse}]" aria-hidden="true"></i>
</template>

<script>

    export default {
        props: {
            icon: '',
            color: '',
            size: '',
            spin: false,
            pulse: false
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Icons/Icon.vue